import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../../themes'

export const ConfirmOrderModalStyle = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: ${440 - (2 * 32)}px;
  padding: 32px 40px;
  color: ${NATIVE_BASE_COLORS.TEXT[900]};

  .confirm-order__title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
    padding-bottom: 32px;
  }

  .confirm-order__list {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    gap: 16px;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .confirm-order__item {
    display: flex;
    width: 100%;
    justify-content: space-between;

    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .confirm-order__button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding-top: 32px;

    button {
      box-sizing: border-box;
      width: 160px;
      height: 40px;
      padding: 10px 12px;
      border-radius: 4px;
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.TN};
      cursor: pointer;
    }

    &--back {
      border: 1px solid ${NATIVE_BASE_COLORS.MUTED[300]};
      color: ${NATIVE_BASE_COLORS.TEXT[900]};
      background-color: ${COLOR.WHITE};
    }

    &--confirm {
      border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK_1}
    }
  }
`
